import { useEffect, useState } from 'react';

const breakpoints = {
    mobile: '(max-width: 639px)',
    tablet: '(min-width: 640px) and (max-width: 1023px)',
    desktop: '(min-width: 1024px)'
};

export const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState('desktop');

    useEffect(() => {
        const { mobile, tablet, desktop } = breakpoints;
        const mediaQueryLists = {
            mobile: window.matchMedia(mobile),
            tablet: window.matchMedia(tablet),
            desktop: window.matchMedia(desktop),
        };

        const getBreakpoint = () => {
            if (mediaQueryLists.mobile.matches) return 'mobile';
            if (mediaQueryLists.tablet.matches) return 'tablet';
            if (mediaQueryLists.desktop.matches) return 'desktop';
            return 'desktop';
        };

        const handleChange = () => {
            setBreakpoint(getBreakpoint());
        };

        // Initial check
        handleChange();

        // Add listeners
        Object.values(mediaQueryLists).forEach((mediaQuery) => {
            mediaQuery.addEventListener('change', handleChange);
        });

        // Cleanup listeners on unmount
        return () => {
            Object.values(mediaQueryLists).forEach((mediaQuery) => {
                mediaQuery.removeEventListener('change', handleChange);
            });
        };
    }, []);

    return breakpoint;
}